import React from "react";

import FwDropdown from "../components/FwDropdown";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
const AddBankDetailsPage = ({
  disburseBank,
  updateDisburseBank,
  ALL_BANKS,
  openDropdown,
  setOpenDropdown,
  disburseBankError,
  disburseBankSuccess,
  disburseBankVerifying,
  submitDisburseBank,
  addBankSource,
  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--form fw-screen--add-bank fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title">
        Add Your Bank Account Details
      </h1>

      <p className="fw-sub fw-add-bank__sub">
        Please add your salary bank account details to
        receive the loan amount.
      </p>

      <div className="fw-add-bank__form">
        <FwDropdown
          id="disburseBankName"
          label="Bank Name"
          value={disburseBank.bankName}
          placeholder="Select bank name"
          options={ALL_BANKS.map(
            (bank) => bank.name
          )}
          openKey={openDropdown}
          setOpenKey={setOpenDropdown}
          onChange={(val) =>
            updateDisburseBank(
              "bankName",
              val
            )
          }
        />

        <label className="fw-field">
          <span>Account Holder’s Name</span>

          <input
            value={disburseBank.holderName}
            placeholder="Joey Tribbiani"
            onChange={(e) =>
              updateDisburseBank(
                "holderName",
                e.target.value
              )
            }
          />
        </label>

        <label className="fw-field">
          <span>Account Number</span>

          <input
            type="tel"
            inputMode="numeric"
            maxLength={18}
            value={disburseBank.accountNumber}
            placeholder="eg. 587658763256785"
            onChange={(e) =>
              updateDisburseBank(
                "accountNumber",
                e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 18)
              )
            }
          />
        </label>

        <label className="fw-field">
          <span>IFSC Code</span>

          <input
            value={disburseBank.ifsc}
            maxLength={11}
            placeholder="eg. HDFC0001234"
            autoCapitalize="characters"
            onChange={(e) =>
              updateDisburseBank(
                "ifsc",
                e.target.value
                  .toUpperCase()
                  .replace(
                    /[^A-Z0-9]/g,
                    ""
                  )
                  .slice(0, 11)
              )
            }
          />
        </label>

        {disburseBankError && (
          <p className="fw-error">
            {disburseBankError}
          </p>
        )}

        {disburseBankSuccess && (
          <p className="fw-success">
            {disburseBankSuccess}
          </p>
        )}
      </div>

      <div className="fw-add-bank__safe">
        <strong>
          100% Safe and Secure
        </strong>
      </div>

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() =>
            setScreen(
              addBankSource === "aaAccount"
                ? "/apply-new/aaAccount"
                : "/apply-new/offer"
                //add /apply-new/ in bioth string 
            )
          }
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={submitDisburseBank}
          disabled={
            disburseBankVerifying ||
            Boolean(disburseBankSuccess)
          }
        >
          {disburseBankVerifying
            ? "Verifying..."
            : disburseBankSuccess
            ? "Verified"
            : "Proceed"}
        </button>
      </div>
    </section>
  );
};

export default AddBankDetailsPage;